import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { ApiService } from 'app/api.service';
import { AppService } from 'app/app.service';
import { UIModalBaseComponent } from 'app/ui/ui-modal-base.component';
import { Util } from 'app/shared/util';

declare const Mangler: any;

@Component({
	selector: 'modal-edit-customer',
	templateUrl: './modal-edit-customer.component.html'
})
export class ModalEditCustomerComponent extends UIModalBaseComponent {

	@ViewChild('multiselectdropdown') multiselectdropdown: ElementRef;

	id;
	data;

	showDeleted = false;
	editedContact = null;

	disabled = false;
	editable = true;
	selectedLabels = [];
	labelList = [];
	isDropdownOpen = false;

	constructor(
		public app: AppService,
		private api: ApiService,
	) {
		super();
		this.editable = !this.app.orgInfo?.disallow_contact_edit;
	}

	open(mdata: any) {
		this.id = mdata.id;
		this.data = null;
		this.showDeleted = false;
		this.editedContact = null;
		this.isDropdownOpen = false;

		if (this.id === 'new') {
			this.disabled = true;
			this.api.customer.new(data => {
				this.disabled = false;
				this.data = data;

				if (mdata.prefill) {
					Mangler.each(mdata.prefill, (k, v) => { this.data.record[k] = v; });
				}

				this.labelList = Mangler.clone(data.label_list);
				// Filter out labels from label_list that are already selected
				this.labelList = this.labelList.filter(label => (!this.selectedLabels.some(selectedLabel => selectedLabel.id === label.id)));
				this.modal.open();
			}, error => {
				this.disabled = false;
				this.app.notifications.showDanger(error.message);
			});
		} else {
			this.disabled = true;
			this.api.customer.details(this.id, data => {
				this.disabled = false;
				this.data = data;
				this.selectedLabels = Mangler.clone(data.record.labels);
				this.labelList = Mangler.clone(data.label_list);
				// Filter out labels from label_list that are already selected
				this.labelList = this.labelList.filter(label => (!this.selectedLabels.some(selectedLabel => selectedLabel.id === label.id)));
				this.modal.open();
			}, error => {
				this.disabled = false;
				this.app.notifications.showDanger(error.message);
			});
		}
	}

	toggleSelection(label: any) {
		const index = this.selectedLabels.findIndex(selectedLabel => selectedLabel.id === label.id);
		if (index !== -1) {
			// Remove the label from selectedLabels and add it back to labelList
			this.selectedLabels.splice(index, 1);
			this.labelList.push(label); // Corrected variable name
		} else {
			// Add the label to selectedLabels and remove it from labelList
			this.selectedLabels.push(label);
			const labelIndex = this.labelList.findIndex(item => item.id === label.id); // Find index of label in label_list
			if (labelIndex !== -1) {
				this.labelList.splice(labelIndex, 1); // Remove label from label_list
			}
		}
	}

	toggleDropdown() {
		this.isDropdownOpen = !this.isDropdownOpen;
	}

	@HostListener('document:click', ['$event'])
	handleClickOutside(event: Event) {
		if (this.multiselectdropdown && !this.multiselectdropdown.nativeElement.contains(event.target)) {
			this.isDropdownOpen = false;
		}
	}

	saveButton() {
		this.disabled = true;
		this.data.record.labels = this.selectedLabels;
		this.api.customer.save(this.data.record, savedId => {
			this.disabled = false;
			this.app.notifications.showSuccess(this.data.record.id === 'new' ? 'Customer created.' : 'Customer updated.');
			// Blank the live address inputs before the modal closes so Chrome cannot
			// offer to save the customer address as the user's personal address. The
			// payload was already sent above, so the save is unaffected.
			Util.blankAddressFields(this.data.record);
			this.modal.close(savedId);
		}, error => {
			this.disabled = false;
			this.app.notifications.showDanger(error.message);
		});
	}

}
